<template>
  <div class="avatar">
    <el-dropdown
      class="avatar-dropdown"
      style="cursor: pointer;"
      placement="bottom"
    >
      <div class="el-dropdown-link">
        <span>{{ users.userName }}</span>
        <i class="iconfont icon-circularDropdown el-icon--right"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-if="passwordModifyVisible"
          ><span @click="modifyPassword">修改密码</span></el-dropdown-item
        >
        <el-dropdown-item :divided="passwordModifyVisible"
          ><span @click="downLoad">通讯服务</span></el-dropdown-item
        >
        <componet :is="customComponentName"></componet>
        <el-dropdown-item
          :divided="passwordModifyVisible"
          style="color: #f56c6b !important;"
        >
          <span @click="logout">退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "Avatar",
  props: { passwordModifyVisible: { type: Boolean, default: true } },
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      baseUrl: this.$store.state.baseUrl,
      customComponentName: this.$store.state.customComponentName
    };
  },
  methods: {
    modifyPassword() {
      top.postMessage(
        {
          handlerType: "modifyPassword"
        },
        "*"
      );
    },
    logout() {
      this.$system.post(
        this.api + "/systematic/userLogout-1",
        {},
        true,
        true,
        this.toLogin,
        this.toLogin
      );
    },
    toLogin() {
      this.$zwxCookie.delCookie("zwxToken");
      this.$zwxCookie.delCookie("userRole");
      window.localStorage.removeItem("loginState");
      this.$router.push({ path: "/login" });
    },
    downLoad() {
      this.$system.downloadUrlFile(
        `setup.exe`,
        `${this.baseUrl}files/setup.exe`
      );
    }
  }
};
</script>

<style lang="less" scoped>
.avatar-dropdown {
  float: right;
  position: relative;
  line-height: 22px;
  margin-right: 26px;

  .el-dropdown-link {
    font-size: 14px;
    color: #ffffff;
  }

  .svg-img {
    float: left;
    height: 22px;
    width: 22px;
    margin-right: 8px;
    border-radius: 50%;
  }
}
.el-dropdown-menu {
  user-select: none;
  padding: 0 20px;
  margin: 4px 0;
}

.el-dropdown-menu__item {
  padding: 0;
  line-height: 43px;
  font-size: 13px;
  font-weight: 400;
  background: 0 0 !important;
  color: #1f2d3d !important;
}

.el-dropdown-menu__item--divided {
  border-top: 1px solid #3a485e;
  margin-top: 0;
}

.el-dropdown-menu__item span {
  display: block;
  height: 43px;
}

.el-dropdown-menu__item--divided:before {
  height: 1px;
}

.el-icon--right {
  margin-left: 10px;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
</style>
